// ─────────────────────────────────────────────────────────────────
// FindRE — App-wide Constants
//
// All magic numbers, labels, and config live here.
// Never hard-code values in components — import from here.
// ─────────────────────────────────────────────────────────────────

export const TODAY = new Date();
export const CURRENT_MONTH_KEY = `${TODAY.getFullYear()}-${String(TODAY.getMonth()+1).padStart(2,'0')}`;

export const MONTHS = [
  { key:"2026-01", label:"يناير ٢٠٢٦",   short:"ين" },
  { key:"2026-02", label:"فبراير ٢٠٢٦",  short:"فبر" },
  { key:"2026-03", label:"مارس ٢٠٢٦",    short:"مار" },
  { key:"2026-04", label:"أبريل ٢٠٢٦",   short:"أبر" },
  { key:"2026-05", label:"مايو ٢٠٢٦",    short:"ماي" },
  { key:"2026-06", label:"يونيو ٢٠٢٦",   short:"يون" },
  { key:"2026-07", label:"يوليو ٢٠٢٦",   short:"يول" },
  { key:"2026-08", label:"أغسطس ٢٠٢٦",   short:"أغس" },
  { key:"2026-09", label:"سبتمبر ٢٠٢٦",  short:"سبت" },
  { key:"2026-10", label:"أكتوبر ٢٠٢٦",  short:"أكت" },
  { key:"2026-11", label:"نوفمبر ٢٠٢٦",  short:"نوف" },
  { key:"2026-12", label:"ديسمبر ٢٠٢٦",  short:"ديس" },
];

/** Tabs that require PIN to access */
export const FINANCIAL_TABS = ["finance", "opsmanager"];

/** Default PIN — user can change in-app */
export const DEFAULT_PIN = "1234";

/** Minimum cash reserve — triggers alert in Cash Flow */
export const CASH_SAFETY_THRESHOLD = 15000;

/** Portfolio breakeven — total annual lease / 12 */
export const BREAKEVEN_MONTHLY = 44383.56;

/** Total annual lease costs across all units */
export const TOTAL_ANNUAL_LEASE = 519600;

export const OP_STATUS = {
  مشغول: { color:"#22c55e", bg:"rgba(34,197,94,0.13)",   border:"rgba(34,197,94,0.25)"  },
  شاغرة: { color:"#38bdf8", bg:"rgba(56,189,248,0.13)",  border:"rgba(56,189,248,0.25)" },
  شاغر:  { color:"#38bdf8", bg:"rgba(56,189,248,0.13)",  border:"rgba(56,189,248,0.25)" }, // legacy
  // "—" = not applicable (contract hadn't started yet, or ended already). Muted grey.
  "—":   { color:"#334155", bg:"rgba(51,65,85,0.08)",    border:"rgba(51,65,85,0.15)"   },
};

export const TENANT_STATUS_CFG = {
  available:  { label:"شاغرة",         color:"#38bdf8", bg:"rgba(56,189,248,0.12)",  dot:"#38bdf8"  },
  expired:    { label:"العقد منتهي",   color:"#6b7280", bg:"rgba(107,114,128,0.13)", dot:"#6b7280"  },
  overdue:    { label:"متأخر",         color:"#ef4444", bg:"rgba(239,68,68,0.12)",   dot:"#ef4444"  },
  due_today:  { label:"مستحق اليوم",  color:"#f59e0b", bg:"rgba(245,158,11,0.14)",  dot:"#f59e0b"  },
  due_soon:   { label:"يستحق قريباً", color:"#f97316", bg:"rgba(249,115,22,0.12)",  dot:"#f97316"  },
  paid:       { label:"مدفوع",         color:"#22c55e", bg:"rgba(34,197,94,0.12)",   dot:"#22c55e"  },
  future:     { label:"قادم",          color:"#a78bfa", bg:"rgba(167,139,250,0.12)", dot:"#a78bfa"  },
};

export const CACHE_KEYS = {
  TENANTS:    "findre-tenants",
  UNITS:      "findre-units",
  MONTHLY:    "findre-monthly",
  PARTNERS:   "findre-partners",
  OWNERSHIP:  "findre-ownership",
  LEASES:     "findre-leases",
  CF_SCHEDULE:"findre-cfschedule",
  CONTRACTS:  "findre-contracts",
  OPS_CONFIG: "findre-opsconfig",
  SB_CONFIG:  "findre-sb-config",
};
